export default __webpack_public_path__ + "static/media/dawn.11c2d552.png";